window.locale = $('html').attr('lang');

/**
 * Show Password on Login Form Page and Navbar
 */
window.showPassword = function (btn) {
    $(btn).blur();
    if (
        $(btn).closest(".form-group").find("input").attr("type") === "password"
    ) {
        $(btn).addClass("active");
        $(btn).find("i").removeClass("fa-eye").addClass("fa-eye-slash");
        $(btn).closest(".form-group").find("input").attr("type", "text");
    } else {
        $(btn).removeClass("active");
        $(btn).find("i").removeClass("fa-eye-slash").addClass("fa-eye");
        $(btn).closest(".form-group").find("input").attr("type", "password");
    }
};

/**
 * Scroll To Top
 */
window.scrollToTop = function () {
    $("html, body").animate({scrollTop: 0}, "fast");
}

/**
 * Scroll to selector element on DOM
 *
 * @param   {string}  selector    The selector where scroll to
 */
window.slideToElement = function (selector = null) {
    // Get the element
    const element = document.querySelector(selector);
    // Get the focus out
    $(this).blur();
    // Check if the element is height is not defined
    if (!element || !element.offsetTop) {
        // Cut the execution
        return;
    }
    // Go to the top
    $("html, body").animate({scrollTop: element.offsetTop}, "fast");
    return false;
};

/**
 * Gets the current parameter value from url
 *
 * @param   {string}    The parameter name
 * @param   {string}    The parameter default value if not exist on url
 *
 * @return  {string}    The current parameter value
 */
window.getCurrentParam = function (paramName, defaultValue) {
    let newValue     = defaultValue;
    let searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has(paramName)) {
        newValue = searchParams.get(paramName);
    }
    return newValue;
}

/**
 * Sets the current parameter value to url
 *
 * @param   {string}    The parameter name
 * @param   {string}    The parameter value to set on url
 */
window.setCurrentParameter = function (paramName, newValue) {
    let searchParams = new URLSearchParams(window.location.search);
    searchParams.set(paramName, newValue);
    history.replaceState({}, "", `?${searchParams.toString()}`);
}

/**
 * Add filter to the facets filter to show the table of elements
 *
 * @param      {string}  facetFilter  The facet name to add
 * @param      {string}  facetValue  The facet value to add
 */
window.addStoragedFacetFilter = function (facetFilter = '', facetValue = '') {
    let storagedFacetsFilter = getStorage('facetsFilter');
    if ($.isEmptyObject(storagedFacetsFilter) || storagedFacetsFilter.length === 0) {
        // Si no tengo filtro en caché lo creo con la nueva faceta filtrada
        let facetsFilter          = {};
        facetsFilter[facetFilter] = facetValue;
        setStorage('facetsFilter', JSON.stringify(facetsFilter));
    } else {
        // Si tengo filtro en caché, añado la nueva faceta filtrada
        storagedFacetsFilter = JSON.parse(storagedFacetsFilter);
        if ('undefined' === typeof storagedFacetsFilter[facetFilter]) {
            storagedFacetsFilter[facetFilter] = facetValue;
        } else {
            if (!(storagedFacetsFilter[facetFilter] instanceof Object)) {
                if (storagedFacetsFilter[facetFilter] !== facetValue) {
                    storagedFacetsFilter[facetFilter] = [
                        storagedFacetsFilter[facetFilter],
                        facetValue,
                    ];
                }
            } else {
                let founded = false;
                storagedFacetsFilter[facetFilter].forEach((storageFacetValue) => {
                    if (storageFacetValue === facetValue) {
                        founded = true;
                    }
                });
                if (!founded) {
                    storagedFacetsFilter[facetFilter].push(facetValue);
                }
            }
        }

        setStorage("facetsFilter", JSON.stringify(storagedFacetsFilter));
    }
};

/**
 * Clean Facets Filter on Local Storage
 */
window.cleanStoragedFacetsFilter = function () {
    setStorage('facetsFilter', '');
};

/**
 * Fill the articles list
 *
 * @param   {array}     article                         The article to fill
 * @param   {string}    selector                        The selector where fill
 * @param   {string}    alternativeElementCartButtons   Alternative buttons
 * @param   {int}       defaultValueQuantityInput       Default value for input quantity
 * @param   {function}  callbackUpdateQuantity          Callback function when update input quantity
 */
window.fillArticle = function (article = [], selector = null, alternativeElementCartButtons = '', defaultValueQuantityInput = 1, callbackUpdateQuantity = 'updateQuantity') {
    // Append the product HTML
    $(`#${selector}`).append(
        `<div class="elementCard" data-idArticle="${article.idarticulo}">
            <div class="elementCardHeader">
                <a href="${urlArticle}/${article.idarticulo}">
                    <img class="elementCardImg rounded-0" src="${appEnv !== 'production' ? urlArticleImageNotFound : urlArticleImage + (typeof article.ean !== "undefined" ? article.ean.substr(0, 7) + '/' + article.ean.substr(0, 12) + articleImageExtension : urlArticleImageNotFound)}" onerror="this.onerror=null;this.src='${urlArticleImageNotFound}';" alt="${article.descripcion}" />
                </a>
            </div>

            <div class="elementCardBody">
                <h5 class="elementTitle elementTitleTruncate">
                    <a href="${urlArticle}/${article.idarticulo}">
                        ${article.descripcion.toUpperCase()}
                    </a>
                </h5>
                <div class="elementSubtext2 elementSubTextTruncate">
                     ${article.autor !== null ? `
                     <div class="btn btn-link p-0 elementTruncate" onclick="searchAuthor('${article.autor}');">
                        ${article.autor.toUpperCase()}
                        </div>` : '&nbsp;'}
                </div>
                ${typeof article.sinopsis !== "undefined" && article.sinopsis !== null && article.sinopsis.length ?
                  `<div class="elementSinopsis text-justify">${article.sinopsis}</div>` :
                  ``}
                <div class="elementMoreInfo">
                    <span class="stateName badge badge-info" data-toggle="tooltip" data-placement="top" title="${trans("State")}">
                        <i class="fas fa-info fa-fw"></i> ${article.nombre_estado}
                    </span>
                    <!-- ${typeof article.isbn !== "undefined" && article.isbn !== null && article.isbn.length ?
                           `<span class="isbn badge badge-info" data-toggle="tooltip" data-placement="top" title="${trans("ISBN")}">
                            <i class="fas fa-qrcode fa-fw"></i> ${article.isbn}
                        </span>` :
                           ``} -->
                    ${typeof article.ean !== "undefined" && article.ean !== null && article.ean.length ?
                      `<span class="ean badge badge-info" data-toggle="tooltip" data-placement="top" title="${trans("EAN")}">
                            <i class="fas fa-barcode fa-fw"></i> ${article.ean}
                        </span>` :
                      ``}
                </div>
            </div>

            <div class="elementCardFooter ${typeof authUser === "undefined" || authUser.idcliente === null ? 'elementCardFooterWithoutCartButtons' : ''}">
                <div class="elementPrices">
                  <span class="price">${parseFloat(article.pvp).toFixed(2).replace('.', ',')}€</span>
                    <span class="oldPrice d-none"></span>
                    <span class="discount d-none badge badge-info">%</span>
                </div>
                ${typeof authUser !== "undefined" && authUser.idcliente !== null ?
                  `<div class="elementCartButtons">

                        <div class="elementQuantity mb-1">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <button class="btn btn-sm btn-primary" type="button" onclick="subtractUnitInputQuantity(${article.idarticulo}, ${callbackUpdateQuantity});">
                                        <i class="fas fa-minus"></i>
                                    </button>
                                </div>
                                <input type="text" pattern="[0-9]" min="1" class="form-control text-center border-primary elementQuantityInput" value="${defaultValueQuantityInput}" onkeydown="allowQuantityValues(event);" onfocusout="changeInputQuantity(${article.idarticulo}, ${callbackUpdateQuantity});"/>
                                <div class="input-group-append">
                                    <button class="btn btn-sm btn-primary" type="button" onclick="addUnitInputQuantity(${article.idarticulo}, ${callbackUpdateQuantity});">
                                        <i class="fas fa-plus"></i>
                                    </button>
                                </div>
                            </div>
                        </div>

                        ${alternativeElementCartButtons.length ?
                          alternativeElementCartButtons :
                          `<button id="addCartArticle-${article.idarticulo}" class="btn btn-primary btn-block btn-sm" type="button" title="${trans('Add to cart')}" onclick="addToCart(${article.idarticulo}, 1);">
                                <i class="fas fa-cart-plus fa-lg mr-1"></i>
                                <span class="textButton">
                                    ${trans('Add to cart')}
                                </span>
                            </button>
                            ${article.stock > 0 && authUser.puede_dropshipping ?
                              `<button id="addDropshippingCartArticle-${article.idarticulo}" class="btn btn-secondary btn-block btn-sm" type="button" title="${trans('DropShipping')}" onclick="addToDropshippingCart(${article.idarticulo}, 1);">
                                    <i class="fas fa-parachute-box fa-lg mr-1"></i>
                                    <span class="textButton">
                                        ${trans('DropShipping')}
                                    </span>
                                </button>` :
                              ``}
                            <!--
                            ${authUser.puede_solicitar_depositos ?
                              `<button id="addDepositCartArticle-${article.idarticulo}" class="btn btn-warning btn-block btn-sm" type="button" title="${trans('Deposit')}" onclick="addToDepositCart(${article.idarticulo}, 1);">
                                    <i class="fas fa-hand-holding fa-lg mr-1"></i>
                                    <span class="textButton">
                                        ${trans('Deposit')}
                                    </span>
                                </button>` :
                              ``}
                            -->
                        `}
                    </div>` :
                  ``}
                </div>
            </div>
        </div>`
    );
    $('[data-toggle="tooltip"]').tooltip();
}

window.fillArticlePackage = function (article = [], selector = null, alternativeElementCartButtons = '', defaultValueQuantityInput = 1, callbackUpdateQuantity = 'updateQuantity') {
    // Append the product HTML
    $(`#${selector}`).append(
        `<div class="elementCard" data-idArticle="${article.id}">
            <div class="elementCardHeader">
                <a href="${urlArticle}/${article.id}">
                    <img class="elementCardImg rounded-0" src="${appEnv !== 'production' ? urlArticleImageNotFound : article.imageURL}" onerror="this.onerror=null;this.src='${urlArticleImageNotFound}';" alt="${article.title}" />
                </a>
            </div>

            <div class="elementCardBody">
                <h5 class="elementTitle elementTitleTruncate">
                    <a href="${urlArticle}/${article.id}">
                        ${article.title}
                    </a>
                </h5>
                <div class="elementSubtext1 elementSubTextTruncate">
                    ${article.publisherTitle}
                </div>
                <div class="elementSubtext2 elementSubTextTruncate">
                    ${article.authorTitle !== null ? article.authorTitle : '&nbsp;'}
                </div>
                ${typeof article.synopsis !== "undefined" && article.synopsis !== null && article.synopsis.length ?
                  `<div class="elementSinopsis text-justify">${article.synopsis}</div>` :
                  ``}
                <div class="elementMoreInfo">
                    <span class="stateName badge badge-info" data-toggle="tooltip" data-placement="top" title="${trans("State")}">
                        <i class="fas fa-info fa-fw"></i> ${article.stateTitle}
                    </span>
                    <!-- ${typeof article.isbn !== "undefined" && article.isbn !== null && article.isbn.length ?
                           `<span class="isbn badge badge-info" data-toggle="tooltip" data-placement="top" title="${trans("ISBN")}">
                            <i class="fas fa-qrcode fa-fw"></i> ${article.isbn}
                        </span>` :
                           ``} -->
                    ${typeof article.ean13 !== "undefined" && article.ean13 !== null && article.ean13.length ?
                      `<span class="ean badge badge-info" data-toggle="tooltip" data-placement="top" title="${trans("EAN")}">
                            <i class="fas fa-barcode fa-fw"></i> ${article.ean13}
                        </span>` :
                      ``}
                </div>
            </div>

            <div class="elementCardFooter ${typeof authUser === "undefined" || authUser.idcliente === null ? 'elementCardFooterWithoutCartButtons' : ''}">
                <div class="elementPrices">
                    ${typeof authUser !== "undefined" && article.freePrice == 'S' ?
                      `<span class="price">${parseFloat(article.pvp).toFixed(2).replace('.', ',')}€</span>
                        <span class="oldPrice d-none"></span>
                        <span class="discount d-none badge badge-info">%</span>` :
                      `<span class="price">${parseFloat(article.pvp).toFixed(2).replace('.', ',')}€</span>
                          <span class="oldPrice d-none"></span>
                          <span class="discount d-none badge badge-info">%</span>`
        }
                </div>
                ${typeof authUser !== "undefined" && authUser.idcliente !== null ?
                  `<div class="elementCartButtons">

                        <div class="elementQuantity mb-1">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <button class="btn btn-sm btn-primary" type="button" onclick="subtractUnitInputQuantity(${article.id}, ${callbackUpdateQuantity});">
                                        <i class="fas fa-minus"></i>
                                    </button>
                                </div>
                                <input type="text" pattern="[0-9]" min="1" class="form-control text-center border-primary elementQuantityInput" value="${defaultValueQuantityInput}" onkeydown="allowQuantityValues(event);" onfocusout="changeInputQuantity(${article.id}, ${callbackUpdateQuantity});"/>
                                <div class="input-group-append">
                                    <button class="btn btn-sm btn-primary" type="button" onclick="addUnitInputQuantity(${article.id}, ${callbackUpdateQuantity});">
                                        <i class="fas fa-plus"></i>
                                    </button>
                                </div>
                            </div>
                        </div>

                        ${alternativeElementCartButtons.length ?
                          alternativeElementCartButtons :
                          `<button id="addCartArticle-${article.id}" class="btn btn-primary btn-block btn-sm" type="button" title="${trans('Add to cart')}" onclick="addToCart(${article.id}, 1);">
                                <i class="fas fa-cart-plus fa-lg mr-1"></i>
                                <span class="textButton">
                                    ${trans('Add to cart')}
                                </span>
                            </button>
                            ${article.stock > 0 && authUser.puede_dropshipping ?
                              `<button id="addDropshippingCartArticle-${article.id}" class="btn btn-secondary btn-block btn-sm" type="button" title="${trans('DropShipping')}" onclick="addToDropshippingCart((${article.id}, 1);">
                                    <i class="fas fa-parachute-box fa-lg mr-1"></i>
                                    <span class="textButton">
                                        ${trans('DropShipping')}
                                    </span>
                                </button>` :
                              ``}
                            ${authUser.puede_solicitar_depositos ?
                              `<button id="addDepositCartArticle-${article.id}" class="btn btn-warning btn-block btn-sm" type="button" title="${trans('Deposit')}" onclick="addToDepositCart(${article.id}, 1);">
                                    <i class="fas fa-hand-holding fa-lg mr-1"></i>
                                    <span class="textButton">
                                        ${trans('Deposit')}
                                    </span>
                                .</button>` :
                              ``}
                        `}
                    </div>` :
                  ``}
                </div>
            </div>
        </div>`
    );
    $('[data-toggle="tooltip"]').tooltip();
}

$(function () {

    // Global ajax settings
    $.ajaxSetup({
        statusCode: {
            419: function () {
                $.alert({
                    columnClass: 'col-md-6',
                    icon:        'fas fa-exclamation-triangle',
                    theme:       'modern',
                    draggable:   false,
                    title:       trans('Attention!'),
                    content:     trans('Sorry, your session has expired. Please refresh and try again.'),
                    buttons:     {
                        reload: {
                            text:     trans('Reload'),
                            btnClass: 'btn-danger float-right',
                            action:   function () {
                                window.location.reload();
                            },
                        },
                    },
                });
            }
        },
        error:      function (jqXHR, textStatus, errorThrown) {
            if (
                $.inArray(jqXHR.status, [
                    0,
                    422,
                    419
                ]) === -1 &&
                !jqXHR.responseJSON &&
                !jqXHR.responseJSON.message
            ) {
                pNotifyErrorConnection();
            }
        },
        headers:    {
            'Cache-Control': 'no-cache',
            'X-CSRF-TOKEN':  _token,
        }
    });

    // Auto convert bootstrap select chosen by class
    if (typeof $().chosen === 'function') {
        $('.selectchosen').chosen();
    }

    //Función Button Scroll/Slide To Top
    $(window).on("scroll", function () {
        if ($(window).scrollTop() >= 150) {
            if (!$("#slideToTop").is(":visible")) {
                $("#slideToTop").fadeIn(500);
            }
        } else {
            $("#slideToTop").fadeOut(500);
        }
    });

    // Disable alert dismiss remove completly html from dom
    $('.alert').on('close.bs.alert', function (e) {
        e.preventDefault();
        $(this).hide();
    });

    // Show file name on custom file input
    $('.custom-file-input').on('change', function () {
        let fileName = $(this).val().split('\\').pop();
        if ('undefined' === fileName || '' === fileName) {
            $(this).next('.custom-file-label').html(transSelectFile);
        } else {
            $(this).next('.custom-file-label').html(fileName);

        }
    })
});


// funciones para el selector de cantidad en minificha

/**
 * Elimina una unidad del input de cantidad
 *
 * @param   {int}       idArticle               The identifier article
 * @param   {function}  callbackUpdateQuantity  Callback function when update input quantity
 */
window.subtractUnitInputQuantity = function (idArticle, callbackUpdateQuantity = function () {
}) {
    var selector = `.elementCard[data-idArticle="${idArticle}"] .elementQuantityInput`;
    var value    = parseInt($(selector).val());
    if (value - 1 > 0) {
        callbackUpdateQuantity(idArticle, value - 1);
    }
};

/**
 * Agrega una unidad al input de cantidad
 *
 * @param   {int}       idArticle               The identifier article
 * @param   {function}  callbackUpdateQuantity  Callback function when update input quantity
 */
window.addUnitInputQuantity = function (idArticle, callbackUpdateQuantity = function () {
}) {
    var selector = `.elementCard[data-idArticle="${idArticle}"] .elementQuantityInput`;
    var value    = parseInt($(selector).val());
    callbackUpdateQuantity(idArticle, value + 1);
};

/**
 * Función que se ejecuta al cambiar el input de cantidad
 *
 * @param   {int}       idArticle               The identifier article
 * @param   {function}  callbackUpdateQuantity  Callback function when update input quantity
 */
window.changeInputQuantity = function (idArticle, callbackUpdateQuantity = function () {
}) {
    const selector = `.elementCard[data-idArticle="${idArticle}"] .elementQuantityInput`;
    const value    = parseInt($(selector).val());
    let newValue   = value;
    // Si está vacío o el valor es 0 o menor, lo pongo a 1
    if (isNaN(value) || value <= 0) {
        newValue = 1;
    }
    callbackUpdateQuantity(idArticle, newValue);
};

/**
 * Actualiza la cantidad del artículo
 *
 * @param   {int}   idArticle   The identifier article
 * @param   {int}   quantity    The new article quantity
 */
window.updateQuantity = function (idArticle, quantity) {
    var selector = `.elementCard[data-idArticle="${idArticle}"]`;

    $(`${selector} .elementQuantityInput`).val(quantity);

    $(`#addCartArticle-${idArticle}`).attr('onclick', `javascript:addToCart(${idArticle}, ${quantity})`);

    if ($(`#addDropshippingCartArticle-${idArticle}`).length) {
        $(`#addDropshippingCartArticle-${idArticle}`).attr('onclick', `javascript:addToDropshippingCart(${idArticle}, ${quantity})`);
    }
    if ($(`#addDepositCartArticle-${idArticle}`).length && authUser.puede_solicitar_depositos) {
        $(`#addDepositCartArticle-${idArticle}`).attr('onclick', `javascript:addToDepositCart(${idArticle}, ${quantity})`);
    }
}


/* Filters */


/**
 *
 * @param title
 */
window.searchPublisher = function (title) {
    cleanStoragedFacetsFilter();
    addStoragedFacetFilter('Publisher', title);
    window.location = `${urlSearch}/*`;
}

/**
 *
 * @param title
 */
window.searchState = function (title) {
    cleanStoragedFacetsFilter();
    addStoragedFacetFilter('State', title);
    //addStoragedFacetFilter('idState', title);
    window.location = `${urlSearch}/*`;
}


/**
 *
 * @param author
 */
window.searchAuthor = function (author) {
    cleanStoragedFacetsFilter();
    addStoragedFacetFilter('Author', author);
    window.location = `${urlSearch}/*`;
}